import styled from 'styled-components';
import { breakpoints, fonts, pxToCssFont } from '@vfit/shared/themes';

export const MainContainer = styled.div<{ color?: string; headerHeight: number }>`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-height: ${({ headerHeight }) => `${headerHeight}px` || '72px'};
  padding: 0 16px;

  span,
  p {
    color: ${({ color }) => color || 'black'};
  }

  .header-top-banner-first-section {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-family: ${fonts.vodafone};
    ${pxToCssFont(16, 22)}
    .after-logo-first-section {
      margin-right: 32px;
      font-family: ${fonts.vodafone};
      font-weight: 700;
    }
  }

  .header-top-banner-second-section {
    .after-logo-button-section {
      margin-right: 12px;
      font-family: ${fonts.vodafone};
      font-weight: 700;
    }
    .after-logo-button-section-html {
      margin-right: 12px;
      font-family: ${fonts.vodafone};
      font-weight: 400;
      color: white;

      ${pxToCssFont(14, 17)}
      @media (min-width: ${breakpoints.tablet}) {
        ${pxToCssFont(16, 17)}
      }
      .p {
        margin: 0;
      }
    }
    display: flex;
    align-items: center;
    button {
      ${pxToCssFont(16, 22)}
      border-color: ${({ color }) => color || 'black'};
      padding-top: 13px;
      padding-bottom: 13px;
    }
    button:first-child {
      font-family: ${fonts.vodafone};
      color: ${({ color }) => color || 'black'};
      text-transform: lowercase;
      span::first-letter {
        text-transform: uppercase;
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    max-height: ${({ headerHeight }) => `${headerHeight}px` || '72px'};
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const LogoContainer = styled.div`
  margin-right: 12px;
  height: 32px;
  img {
    object-fit: contain !important;
    width: auto !important;
  }
`;

